import {isAutohomeApp} from '../../../../common/util';
import store from '../../modules/store/index.js';
export default {
    data: {
        //容器标识
        isInApp: /auto_android|auto_iphone/.test(navigator.userAgent),
        //是否已经弹出过IM询问框
        hasIntercepted: false,
        // 是否加载完成JSBridge
        isGetJSBridge: false,
        envBase: 0, // 1 ->app, 2 -> web
        isTrigger: false //标志位，防止反复触发
    },
    computed: {
        returnBlockShow: {
            get() {
                return store.returnBlockShow;
            },
            set(val) {
                store.returnBlockShow = val;
            }
        },
        returnMainSeriesFlag() {
            return store.returnMainSeriesFlag;
        },
        mainSeriesId() {
            return store.returnMainSeries
        }
    },
    methods: {
        // 加载JSBridge
        getJSBridge: function () {
            var _this = this;
            if (isAutohomeApp()) {
            // 在app里
                _this.env = 1;
                var body = document.querySelector('body');
                var script1 = document.createElement('script');
                body.appendChild(script1);
                script1.src = 'https://x.autoimg.cn/app/scripts/ahapp-2.0.js';
                script1.onload = function () {
                    _this.isGetJSBridge = true;
                };
            } else {
                // 不在app里
                _this.env = 2;
            }
        },
        // 比较主软的版本
        compareAppVersion: function (now, appoint) {
            var nowArr = now.split('.');
            var appointArr = appoint.split('.');
            for (var i = 0; i < 3; i++) {
                nowArr[i] = parseFloat(nowArr[i]);
                appointArr[i] = parseFloat(appointArr[i]);
            }
            if (nowArr[0] > appointArr[0]) {
                return 'nowBig';
            } else if (nowArr[0] == appointArr[0]) {
                if (nowArr[1] > appointArr[1]) {
                    return 'nowBig';
                } else if (nowArr[1] == appointArr[1]) {
                    if (nowArr[2] > appointArr[2]) {
                        return 'nowBig';
                    } else if (nowArr[2] == appointArr[2]) {
                        return 'equal'
                    } else {
                        return 'appointBig'
                    }
                } else {
                    return 'appointBig'
                }
            } else {
                return 'appointBig'
            }
        },
        loadImTrigger: function (seriesId) {
            let _this = this;
            var regListener = function() {
                if (isAutohomeApp() && _this.isGetJSBridge && window.AHJavascriptBridge) {
                    AHJavascriptBridge.bindMethod("interceptH5ClickEvent", function (args, callback) {
                        if (_this.showReturnData(seriesId)) {
                            _this.setReturnData(seriesId);
                            _this.returnBlockShow = true;
                            // _this.isTrigger = true;
                            if (callback) {
                                callback('111');
                            }
                        }
                    });
                    return;
                    // if (_this.showReturnData(seriesId)) {
                    // }
                }
            }
            regListener();
        },
        // 设置返回的localStorage
        setReturnData: function (seriesId) {
            var isHaveSeriesId = false;
            if (localStorage.getItem('HQreturnData2')) {
                var returnData = JSON.parse(localStorage.getItem('HQreturnData2'));
                // if (new Date().getTime() > returnData.date) {
                //     isHaveSeriesId = true;
                // }

                for (var i = 0; i < returnData.length; i++) {
                    if (returnData[i].seriesId == seriesId && new Date().getTime() > returnData[i].date) {
                        isHaveSeriesId = true;
                        returnData[i].date = new Date().getTime() + 60 * 60 * 1000;
                    }
                }

                if (!isHaveSeriesId) {
                    returnData.push({ seriesId: seriesId, date: (new Date().getTime() + 24 * 60 * 60 * 1000) })
                }
                localStorage.setItem('HQreturnData2', JSON.stringify(returnData));
            } else {
                var tmpObj = {
                    seriesId: seriesId,
                    date: (new Date().getTime() + 60 * 60 * 1000)
                }
                var returnData = [tmpObj];
                localStorage.setItem('HQreturnData2', JSON.stringify(returnData));
            }
        },
        // 查找当前车系是否要展示返回弹窗
        showReturnData: function (seriesId) {
            var tmpSeriesIdArr = [];
            if (!localStorage.getItem('HQreturnData2')) {
                return true;
            }
            var returnData = JSON.parse(localStorage.getItem('HQreturnData2'));
            // if (returnData && new Date().getTime() > returnData.date) {
            //     return true;
            // } else {
            //     return false;
            // }
            if (returnData) {
                for (var i = 0; i < returnData.length; i++) {
                    tmpSeriesIdArr.push(returnData[i].seriesId);
                    if (returnData[i].seriesId == seriesId && new Date().getTime() > returnData[i].date) {
                        return true;
                    }
                }
                if (tmpSeriesIdArr.indexOf(seriesId) > -1) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }

        
    }
    // ,
    // watch: {
    //     returnMainSeriesFlag() {
    //         this.loadImTrigger(this.mainSeriesId);
    //     }
    // }
}